import React from 'react'
import Servicebox from './Servicebox'
import img1 from "../images/1.svg"
import img2 from "../images/2.svg"
import img3 from "../images/3.svg"
import img4 from "../images/4.svg"

function Services() {
    return (
        <>
            <div id="features">
                <h1>SERVICES</h1>
                <div className="a-container">
                    <Servicebox image={img3} title="High Defination Camera" paragraph="We have Canon Family having 6d,6d Mark II, 5D Mark II" />
                    <Servicebox image={img1} title="Strong Portfolio" paragraph="We have one click event booking facility on our website" />
                    <Servicebox image={img2} title="Reasonable Prices" paragraph="We have one click event booking facility on our website" />
                    <Servicebox image={img4} title="One Click Booking" paragraph="We have one click event booking facility on our website" />
                </div>
            </div>
        </>
    )
}

export default Services
